var _path, _path2, _circle, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPaymentAutomation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.5 42C76.5 61.0538 61.0538 76.5 42 76.5C22.9462 76.5 7.5 61.0538 7.5 42C7.5 22.9462 22.9462 7.5 42 7.5C61.0538 7.5 76.5 22.9462 76.5 42Z",
    fill: "white",
    fillOpacity: 0.4,
    stroke: "#222831"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5787 61L30 44.2885V40.3501H33.1929C34.4701 40.3501 35.5876 40.1727 36.5455 39.8179C37.5388 39.4276 38.3548 38.8777 38.9933 38.1681C39.6674 37.4585 40.1286 36.6069 40.3769 35.6134H30V31.6751H40.3237C40.1109 30.7526 39.7384 29.9365 39.2062 29.2269C38.7095 28.5173 38.0355 27.9673 37.184 27.577C36.3681 27.1513 35.3747 26.9384 34.204 26.9384H30V23H54V26.9384H45.6452C46.2483 27.6125 46.745 28.3399 47.1353 29.1204C47.561 29.901 47.8448 30.7526 47.9867 31.6751H54V35.6134H48.0931C47.7384 38.239 46.7273 40.2969 45.0599 41.7871C43.3925 43.2418 41.2461 44.2353 38.6208 44.7675L49.051 61H39.5787Z",
    fill: "url(#paint0_linear_4945_18567)",
    stroke: "#222831"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 13.5,
    fill: "white",
    stroke: "#222831"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.9499 59.8391C74.591 60.3637 74.6855 61.3087 74.1609 61.9499L65.1609 72.9499C64.8926 73.2779 64.498 73.4771 64.0747 73.4982C63.6515 73.5193 63.239 73.3604 62.9393 73.0607L58.9393 69.0607C58.3536 68.4749 58.3536 67.5252 58.9393 66.9394C59.5251 66.3536 60.4749 66.3536 61.0607 66.9394L63.8886 69.7674L71.8391 60.0502C72.3637 59.409 73.3087 59.3145 73.9499 59.8391Z",
    fill: "url(#paint1_linear_4945_18567)",
    stroke: "#222831"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4945_18567",
    x1: 42,
    y1: 23,
    x2: 42,
    y2: 61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4945_18567",
    x1: 66.5,
    y1: 59.5,
    x2: 66.5,
    y2: 73.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF4A01"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE9E0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentAutomation);
export default __webpack_public_path__ + "static/media/payment-automation.fd8759484b583879b2ec12626db64455.svg";
export { ForwardRef as ReactComponent };